export default {
  sm: `
  일상 속 다양한 기록과 추억은 데이터센터에
  저장됩니다. 삶의 기록인 데이터를 안전하게
  지키고, 나아가 환경과 미래를 온전하게 
  유지하는 것, 데이터센터 각이 기술 
  플랫폼으로서 가지는 책임입니다. 현재의
  지식이 다음 세대를 위한 지식의 토대가
  될 수 있도록, 더 나은 환경을 위해
  데이터센터 각의 노력은 계속됩니다.
  `,
  md: `
  일상 속 다양한 기록과 추억은
  데이터센터에 저장됩니다.
  삶의 기록인 데이터를 안전하게 지키고,
  나아가 환경과 미래를 온전하게 유지하는
  것, 데이터센터 각이 기술 플랫폼으로서
  가지는 책임입니다. 현재의 지식이
  다음 세대를 위한 지식의 토대가
  될 수 있도록, 더 나은 환경을 위해
  데이터센터 각의 노력은 계속됩니다.
  `,
  lg: `
  일상 속 다양한 기록과 추억은 데이터센터에 저장됩니다.
  삶의 기록인 데이터를 안전하게 지키고, 나아가 환경과
  미래를 온전하게 유지하는 것, 데이터센터 각이 기술
  플랫폼으로서 가지는 책임입니다. 현재의 지식이 다음
  세대를 위한 지식의 토대가 될 수 있도록, 더 나은 환경을
  위해 데이터센터 각의 노력은 계속됩니다.
  `,
  xxl: `
  일상 속 다양한 기록과 추억은 데이터센터에 저장됩니다.
  삶의 기록인 데이터를 안전하게 지키고, 나아가 환경과 미래를 온전하게
  유지하는 것, 데이터센터 각이 기술 플랫폼으로서 가지는 책임입니다.
  현재의 지식이 다음 세대를 위한 지식의 토대가 될 수 있도록,
  더 나은 환경을 위해 데이터센터 각의 노력은 계속됩니다.
  `
};
